import * as React from 'react';
import * as classNames from 'classnames';
import * as I18n from 'i18n-js';
import FacetOption from './facet_option';
import FilterLink from './filter_link';
import bind from '../bind';
import { FilterOption } from './search_filters';
import { withUserContext, IUserContext } from './user_context_provider';
import { isExperimentEnabled } from '../user_context_helpers';
import { experiments } from '../constants';
import { withUrlContext, IUrl } from '../url_context';

interface IExternalProps {
  option: FilterOption;
  checkbox?: boolean;
  children?: JSX.Element;
  childActive?: boolean;
  url?: IUrl;
}

type IProps = IExternalProps & IUserContext;

class SelectFacetOption extends React.Component<IProps> {
  get zeroCount() {
    return this.props.option.count && this.props.option.count.value === 0;
  }

  @bind
  onLinkClick(evt) {
    if (this.zeroCount) {
      evt.preventDefault();
    }
  }

  viewingSearchRollup() {
    const searchRollupEnabled = this.props.user && isExperimentEnabled(this.props.user, experiments.NEO_MARKETPLACE);
    return searchRollupEnabled && this.props.url?.pathname === '/marketplace';
  }

  linkParams() {
    const useUnset = this.props.option.selected && this.props.checkbox;
    const values = useUnset ? this.props.option.unsetValues : this.props.option.setValues;

    return { [this.props.option.paramName]: values };
  }

  renderCount() {
    if (!this.props.option.count || this.viewingSearchRollup()) {
      return null;
    }

    return (
      <div className="facet__option__count">
        ({I18n.toNumber(this.props.option.count.value, { precision: 0 })})
      </div>
    );
  }

  render() {
    const { option } = this.props;
    const linkClass = classNames({
      facet__link: true,
      'facet__link--checkbox': this.props.checkbox,
      'facet__link--active': option.selected,
    });

    return (
      <FacetOption
        active={option.selected}
        childActive={this.props.childActive}
        disabled={this.zeroCount}
        paramName={option.paramName}
      >
        <FilterLink
          onClick={this.onLinkClick}
          className={linkClass}
          params={this.linkParams()}
          data-checked={option.selected || null}
          data-disabled={this.zeroCount || null}
          rel="nofollow"
        >
          <div>
            <span className="mr-space">{option.name}</span>
            {this.renderCount()}
          </div>
        </FilterLink>
        {this.props.children}
      </FacetOption>
    );
  }
}

export default withUserContext<IProps>(withUrlContext(SelectFacetOption));



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/src/components/select_facet_option.tsx